import { commonAxios } from "../../Global/CommonAxios"
import { setAlert } from "./AlertActions"
export const fetchPackageList = (url, setData, setLoader, loader) => (dispatch, getState) => {
    commonAxios(url, {}, dispatch, getState().auth.token)
        .then((res) => {
            if (res.status) {
                setData(res.data)
            }
            setLoader({
                ...loader,
                fetch: false
            })
        })
        .catch((err) => {
            console.log(err)
            setLoader({
                ...loader,
                fetch: false
            })

        })
}
export const BuyPackageAction = (url, data, navigation, setLoader, loader, handleClose) => (dispatch, getState) => {
    commonAxios(url, data, dispatch, getState().auth.token)
        .then((res) => {
            if (res.status) {

                navigation('/amountpage', { state: { "paymentkey": res.data.paymentkey } })

            } else {
                dispatch(setAlert(res.msg))
            }
            handleClose()
            setLoader({
                ...loader,
                save: false
            })
        })
        .catch((err) => {
            console.log(err)
            setLoader({
                ...loader,
                save: false
            })

        })

}
export const creatorFetchData = (url, setData, setLoader, loader) => (dispatch, getState) => {
    commonAxios(url, {}, dispatch, getState().auth.token)
        .then((res) => {
            if (res.status) {
                setData(res.data)
            }
            setLoader({
                ...loader,
                fetch: false
            })
        })
        .catch((err) => {
            console.log(err)
            setLoader({
                ...loader,
                fetch: false
            })

        })
}
// creatorWalletHistory
export const creatorWalletHistory = (url, formData, setData, setTotalLength, setLoader, loader) => (dispatch, getState) => {
    commonAxios(url, formData, dispatch, getState().auth.token)
        .then((res) => {
            if (res.status) {
                setData(res.data.list)
                setTotalLength(res.data.total_count)
            }
            setLoader({
                ...loader,
                fetch: false
            })
        })
        .catch((err) => {
            console.log(err)
            setLoader({
                ...loader,
                fetch: false
            })

        })
}